import React from "react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { LOGO_HORIZONTAL } from "@/lib/brand";

export default function Login() {
  const [accepted, setAccepted] = React.useState(false);
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const handleLogin = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-50 px-4">
      <div className="w-full max-w-md bg-white rounded-3xl border border-neutral-200 shadow-[0_20px_60px_rgba(0,0,0,0.08)] p-8 animate-fade-up">
        <img src={LOGO_HORIZONTAL} alt="MCTECH EVENTOS" className="h-12 w-auto mx-auto" />
        <h1 className="font-display font-extrabold text-2xl text-center mt-5">Panel de Organizador</h1>
        <p className="text-neutral-500 text-center mt-2 text-sm">Inicia sesión con Google para crear y gestionar tus rifas.</p>
        <label className="flex items-start gap-2.5 mt-8 cursor-pointer max-sm:gap-3 max-sm:py-2">
          <Checkbox data-testid="login-accept-terms" checked={accepted} onCheckedChange={(v) => setAccepted(!!v)} className="mt-0.5 max-sm:h-5 max-sm:w-5" />
          <span className="text-xs text-neutral-600 leading-relaxed max-sm:text-sm">He leído y acepto los <a href="/terminos" target="_blank" rel="noreferrer" className="font-semibold text-[#0092CC] underline">Términos y Condiciones</a></span>
        </label>
        <Button data-testid="google-login-btn" onClick={handleLogin} disabled={!accepted} className="w-full mt-4 h-12 rounded-xl bg-white border border-neutral-300 text-neutral-800 hover:bg-neutral-50 text-base disabled:opacity-50 disabled:cursor-not-allowed">
          <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" className="w-5 h-5 mr-3" />
          Continuar con Google
        </Button>
        <p className="text-xs text-neutral-400 text-center mt-6">Los compradores no necesitan cuenta. Solo los organizadores inician sesión aquí.</p>
      </div>
    </div>
  );
}
